import { render, staticRenderFns } from "./Rotator.vue?vue&type=template&id=0c3dad73&scoped=true"
import script from "./Rotator.vue?vue&type=script&lang=js"
export * from "./Rotator.vue?vue&type=script&lang=js"
import style0 from "./Rotator.vue?vue&type=style&index=0&id=0c3dad73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3dad73",
  null
  
)

export default component.exports